import React from 'react';
type CheckboxFieldProps = {
  name: string;
  children: React.ReactNode;
  tone?: 'light' | 'dark';
  className?: string;
  error?: string;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'name' | 'type' | 'className' | 'children'>;
export function CheckboxField({
  name,
  children,
  tone = 'light',
  className = '',
  error,
  id,
  ...rest
}: CheckboxFieldProps) {
  const fieldId = id ?? `f-${name}`;
  const text = tone === 'dark' ? 'text-cream/85' : 'text-graphite';
  return <div className={className} data-id="element-199" data-mp="1vefi0rbg6kia">
      <label htmlFor={fieldId} className={`flex cursor-pointer items-start gap-3 text-sm leading-relaxed ${text}`} data-id="element-200" data-mp="1vdmjueqk13br">
        <input id={fieldId} name={name} type="checkbox" aria-invalid={error ? true : undefined} className={`mt-[3px] h-4 w-4 shrink-0 cursor-pointer rounded-none ${tone === 'dark' ? 'accent-[#FAF7F2]' : 'accent-[#1E1E1E]'}`} {...rest} data-id="element-201" data-mp="1heef76bmh306" />
        <span data-id="element-202" data-mp="b05f8ck3wkke">{children}</span>
      </label>
      {error && <p className={`mt-1 pl-7 text-sm ${tone === 'dark' ? 'text-blush' : 'text-[#9B2C2C]'}`} data-id="element-203" data-mp="1rit3bnceeqci">{error}</p>}
    </div>;
}